// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__5HPC6","col":"styles_col__2kcJX"};